import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const coachApi = createApi({
  reducerPath: 'coaches',
  tagTypes: ['Coach'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchCoachs: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Coach', id: 'LIST' },
                ...result.map((r) => ({ type: 'Coach', id: r.id })),
              ]
            : [{ type: 'Coach', id: 'LIST' }],
        query: () => ({
          url: `?resource=coach&order=created_at.asc`,
          method: 'GET',
        }),
      }),

      fetchCoach: builder.query({
        providesTags: (result, error, arg) => [{ type: 'Coach', id: arg }],
        query: (coachId) => ({
          url: `?resource=coach&id=eq.${coachId}`,
          method: 'GET',
        }),
      }),

      // Resuelve el coach por el email del usuario de Supabase (login magic link).
      fetchCoachByEmail: builder.query({
        providesTags: (result) =>
          result && result.length > 0
            ? [{ type: 'Coach', id: result[0].id }]
            : [{ type: 'Coach', id: 'LIST' }],
        query: (email) => ({
          url: `?resource=coach&email=eq.${encodeURIComponent(email)}`,
          method: 'GET',
        }),
      }),

      createCoach: builder.mutation({
        invalidatesTags: [{ type: 'Coach', id: 'LIST' }],
        query: (data) => ({
          url: `?resource=coach`,
          method: 'POST',
          body: data,
        }),
      }),

      updateCoach: builder.mutation({
        invalidatesTags: (result, error, { id: coachId }) => [
          { type: 'Coach', id: coachId },
          { type: 'Coach', id: 'LIST' },
        ],
        query: ({ id: coachId, submitData }) => ({
          url: `?resource=coach&id=eq.${coachId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),

      deleteCoach: builder.mutation({
        invalidatesTags: (result, error, coachId) => [
          { type: 'Coach', id: coachId },
          { type: 'Coach', id: 'LIST' },
        ],
        query: (coachId) => ({
          url: `?resource=coach&id=eq.${coachId}`,
          method: 'DELETE',
        }),
      }),
    };
  },
});

export const {
  useFetchCoachsQuery,
  useCreateCoachMutation,
  useUpdateCoachMutation,
  useFetchCoachQuery,
  useFetchCoachByEmailQuery,
  useDeleteCoachMutation,
} = coachApi;

export { coachApi };
